import { render } from "./ApplicantDetail.vue?vue&type=template&id=bd63e8a0&scoped=true"
import script from "./ApplicantDetail.vue?vue&type=script&lang=js"
export * from "./ApplicantDetail.vue?vue&type=script&lang=js"

import "./ApplicantDetail.vue?vue&type=style&index=0&id=bd63e8a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd63e8a0"]])

export default __exports__